import { Button, Input } from '@fullscreendigital/carrefour-dex-fe'
import { useMemo } from 'react'
import { getValidationSchema, initialValues, isEmpty } from './helpers'
import { useFormik } from 'formik'
import { useNavigate } from 'react-router-dom'
import { Grid, Typography } from '@mui/material'
import { useNotification } from 'hooks'
import { makeCoreGetRequest, makeCorePostRequest } from 'utils/api'
import { useMutation, useQuery } from 'react-query'
import { formatErrorMessage } from 'utils/formatting'
import { URLS } from 'components/shop-reception/mobile/constants'

const RegisterTruck = () => {
  const navigate = useNavigate()
  const { showNotification } = useNotification()

  const { data: hubName, isLoading: isLoadingHubName } = useQuery(
    ['hub-name'],
    async () => {
      const response = await makeCoreGetRequest(`/shop-reception-mobile/home/hub-name`, null)
      return response || []
    },
    {
      onError: error => {
        showNotification({
          message: `A aparut o eroare la obtinerea datelor despre hub. ${formatErrorMessage(
            error
          )}`,
          type: 'error'
        })
      }
    }
  )

  const createTruck = async (values: any) => {
    return await makeCorePostRequest(`/shop-reception-mobile/truck/hub/save`, values)
  }

  const { isLoading, mutate } = useMutation(createTruck, {
    onSuccess: (res) => {
      showNotification({
        message: `Camionul a fost inregistrat cu success.`,
        type: 'success'
      })
      navigate(URLS.AUTH_REGISTER_TRUCK_STEP_2, { state: { truckId: res.id } })
    },
    onError: error => {
      showNotification({
        message: `A aparut o eroare ${formatErrorMessage(error)}`,
        type: 'error'
      })
    }
  })

  const validationSchema = useMemo(() => getValidationSchema(), [])
  const formik = useFormik({
    enableReinitialize: false,
    validateOnChange: false,
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values: any) => {
      mutate(values)
    }
  })

  const disableNextButton = useMemo(
    () =>
      isEmpty(formik.values.truckNumber) ||
      isEmpty(formik.values.phoneNumber),
    [formik.values.truckNumber, formik.values.phoneNumber]
  )

  return (
    <Grid container spacing={2} justifyContent={'center'}>
      <Typography
        component="h2"
        variant="medium"
        style={{ textAlign: 'center', textTransform: 'uppercase' }}
        pt={2}
      >
        {hubName?.value}
      </Typography>
      <Grid xs={10} item>
        <Input
          type="text"
          value={formik.values.truckNumber}
          onChange={event =>
            formik.setFieldValue('truckNumber', (event.target as HTMLInputElement).value)
          }
          label="Numar inmatriculare"
          variant="outlined"
          style={{ width: '100%' }}
          error={!!formik.errors.truckNumber}
          helperText={formik.errors.truckNumber as string}
          required
        />
      </Grid>
      <Grid xs={10} item>
        <Input
          type="text"
          value={formik.values.phoneNumber}
          onChange={event =>
            formik.setFieldValue('phoneNumber', (event.target as HTMLInputElement).value)
          }
          label="Telefon"
          variant="outlined"
          style={{ width: '100%' }}
          error={!!formik.errors.phoneNumber}
          helperText={formik.errors.phoneNumber as string}
          required
        />
      </Grid>
      <Grid xs={10} item>
        <Button
          variant="outlined"
          label="Pasul urmator"
          onClick={() => formik.handleSubmit()}
          style={{ width: '100%' }}
          disabled={disableNextButton || isLoading}
        />
      </Grid>
    </Grid>
  )
}

export default RegisterTruck
